module.exports = __webpack_public_path__ + "media/Intitlement_R2.5ecff218.mp4";